<template>
  <div class="app-dropdown">
    <div class="btn-icon" @click="open">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <div
      v-if="isOpen"
      v-down-outside="onOutside"
      class="content"
      @click="handleClose"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { downOutside } from 'app/utils/directives/down-outside';

export default {
  name: 'Dropdown',
  components: {},
  directives: {
    downOutside,
  },
  data() {
    return {
      isOpen: false,
      willClose: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    open() {
      if (!this.willClose) {
        this.isOpen = true;
      }
    },
    close() {
      this.isOpen = false;
    },
    handleClose(e) {
      for (let i = 0; i < e.path.length; i++) {
        if (e.path[i].className == 'item') {
          this.close();
          return;
        }
      }
    },
    onOutside() {
      this.willClose = true;
      setTimeout(() => {
        this.willClose = false;
      }, 100);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-dropdown {
  position: relative;
  .btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 33px;
    height: 33px;
    .dot {
      background: #eaefff;
      border: 1px solid #d7e2fe;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      margin: 1px;
    }
  }
  .content {
    position: absolute;
    top: 30px;
    right: -3px;
    background: white;
    border-radius: 6px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);

    padding: 12px 14px;
    color: #525252;

    .dropdown-group {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0px;
      }
    }

    .item {
      cursor: pointer;
      display: flex;
      align-items: center;
      min-width: 150px;
      font-size: 12px;

      .icon {
        color: #9e9e9e;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        flex-shrink: 0;

        width: 26px;
        height: 32px;
        svg {
          width: 15px;
          height: auto;
          margin: 0;
          path {
            fill: #9e9e9e;
          }
        }
      }
    }
  }
}
</style>
